import { render, staticRenderFns } from "./MatchSet.vue?vue&type=template&id=00fe9cc4"
import script from "./MatchSet.vue?vue&type=script&lang=js"
export * from "./MatchSet.vue?vue&type=script&lang=js"
import style0 from "./MatchSet.vue?vue&type=style&index=0&id=00fe9cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports